export const INSTANCE_ID_WIX = {
    BLOG: '98f34744-730d-486d-b8cd-ac3eb645c1c3',
    BLOG_TEST: '8245698b-1236-4a15-94d5-84be2a0f0fd3',
    BLOG_BASE44: 'ff8131de-5a48-401d-8cba-50b640acee20',
    BLOG_ES: '065c05e6-04dc-474d-9737-eddcd6eec281',
    BLOG_PT: '6bbd3403-27c6-4952-9710-1e8d0526872c',
    BLOG_FR: '1050dbb5-efb9-418f-bf46-a0f0e182b6b1',
    BLOG_JA: '0aae1288-df0f-4a5c-be54-6f399ac9728b',
    BLOG_RU: '31dd8a7e-402c-43a9-aea1-86d9e3596684',
    PHOTOGRAPHY: 'd8c0dd7d-d6de-498b-a6da-c419d89696bb',
    RESTAURANTS: 'b50d055c-6efd-45f7-b1e5-209d9dffc503',
    FITNESS: 'b14e159f-0e29-4e67-86f7-1a376c2a5fba',
    CREATIVE: 'b96367b6-0a1c-4ca2-9265-e7316cc57ce2',
    CONTENT_WRITING: '0b7ab026-fa77-405a-b79e-93e4fc5fb4b6',
    BA: 'f1aac22b-0cc2-45f6-acb1-1834c19ad671',
    ANSWERS: '0f6e9dd4-46a6-436b-8fbb-e63bddbb2466',
    ECOMMERCE: '9413fc6a-33e7-48f5-b8bb-d8e718291c53',
    BLOG_PL: '94e4f411-af53-4e21-a0c0-a96fbf5548af',
    BLOG_TR: '479bfaeb-3b45-4da7-b121-6d7f57e64fe4',
    BLOG_IT: '71f6a8e4-15ad-4dd7-bb8d-3ee2e95c2db3',
    BLOG_KO: '5b15985b-2459-4f0b-b634-fb841908d3f5',
    BLOG_NL: '46ca18b0-7e1b-49a6-86c9-eb36bbf34362',
    BLOG_DE: 'e3f76ac2-fdf4-4678-aeec-f7246ba900fc',
    BLOG_AUTOMATION: '994f8549-69d0-40c8-b9e5-a7d1ca59d625', // https://communitiesauto.wixsite.com/const-amp-header
};
export const WP_BLOGS = [
    INSTANCE_ID_WIX.BLOG,
    INSTANCE_ID_WIX.BLOG_ES,
    INSTANCE_ID_WIX.BLOG_PT,
    INSTANCE_ID_WIX.BLOG_FR,
    INSTANCE_ID_WIX.BLOG_JA,
    INSTANCE_ID_WIX.BLOG_RU,
    INSTANCE_ID_WIX.PHOTOGRAPHY,
    INSTANCE_ID_WIX.RESTAURANTS,
    INSTANCE_ID_WIX.FITNESS,
    INSTANCE_ID_WIX.CREATIVE,
    INSTANCE_ID_WIX.CONTENT_WRITING,
    INSTANCE_ID_WIX.BA,
    INSTANCE_ID_WIX.ECOMMERCE,
    INSTANCE_ID_WIX.BLOG_PL,
    INSTANCE_ID_WIX.BLOG_TR,
    INSTANCE_ID_WIX.BLOG_IT,
    INSTANCE_ID_WIX.BLOG_KO,
    INSTANCE_ID_WIX.BLOG_NL,
    INSTANCE_ID_WIX.BLOG_DE,
];
export const SITE_URLS = {
    [INSTANCE_ID_WIX.ANSWERS]: 'https://www.wix.com/wixanswers/main',
    [INSTANCE_ID_WIX.CONTENT_WRITING]: 'https://www.wix.com/wordsmatter/blog',
    [INSTANCE_ID_WIX.CREATIVE]: 'https://www.wix.com/blog/creative',
    [INSTANCE_ID_WIX.BA]: 'https://www.wix.com/blog/business-analytics',
    [INSTANCE_ID_WIX.BLOG]: 'https://www.wix.com/blog',
    [INSTANCE_ID_WIX.BLOG_ES]: 'https://es.wix.com/blog',
    [INSTANCE_ID_WIX.BLOG_PT]: 'https://pt.wix.com/blog',
    [INSTANCE_ID_WIX.BLOG_FR]: 'https://fr.wix.com/blog',
    [INSTANCE_ID_WIX.BLOG_JA]: 'https://ja.wix.com/blog',
    [INSTANCE_ID_WIX.BLOG_RU]: 'https://ru.wix.com/blog',
    [INSTANCE_ID_WIX.PHOTOGRAPHY]: 'https://www.wix.com/blog/photography',
    [INSTANCE_ID_WIX.RESTAURANTS]: 'https://www.wix.com/blog/restaurants',
    [INSTANCE_ID_WIX.FITNESS]: 'https://www.wix.com/blog/fitness',
    [INSTANCE_ID_WIX.ECOMMERCE]: 'https://www.wix.com/blog/ecommerce',
    [INSTANCE_ID_WIX.BLOG_PL]: 'https://pl.wix.com/blog',
    [INSTANCE_ID_WIX.BLOG_TR]: 'https://tr.wix.com/blog',
    [INSTANCE_ID_WIX.BLOG_IT]: 'https://it.wix.com/blog',
    [INSTANCE_ID_WIX.BLOG_KO]: 'https://ko.wix.com/blog',
    [INSTANCE_ID_WIX.BLOG_NL]: 'https://nl.wix.com/blog',
    [INSTANCE_ID_WIX.BLOG_DE]: 'https://de.wix.com/blog',
    [INSTANCE_ID_WIX.BLOG_AUTOMATION]: 'https://communitiesauto.wixsite.com/const-amp-header',
};
export const FEED_PAGE_URLS = {
    [INSTANCE_ID_WIX.ANSWERS]: SITE_URLS[INSTANCE_ID_WIX.ANSWERS],
    [INSTANCE_ID_WIX.CONTENT_WRITING]: SITE_URLS[INSTANCE_ID_WIX.CONTENT_WRITING],
    [INSTANCE_ID_WIX.CREATIVE]: SITE_URLS[INSTANCE_ID_WIX.CREATIVE],
    [INSTANCE_ID_WIX.BA]: SITE_URLS[INSTANCE_ID_WIX.BA],
    [INSTANCE_ID_WIX.BLOG]: SITE_URLS[INSTANCE_ID_WIX.BLOG],
    [INSTANCE_ID_WIX.BLOG_ES]: SITE_URLS[INSTANCE_ID_WIX.BLOG_ES],
    [INSTANCE_ID_WIX.BLOG_PT]: SITE_URLS[INSTANCE_ID_WIX.BLOG_PT],
    [INSTANCE_ID_WIX.BLOG_FR]: SITE_URLS[INSTANCE_ID_WIX.BLOG_FR],
    [INSTANCE_ID_WIX.BLOG_JA]: SITE_URLS[INSTANCE_ID_WIX.BLOG_JA],
    [INSTANCE_ID_WIX.BLOG_RU]: SITE_URLS[INSTANCE_ID_WIX.BLOG_RU],
    [INSTANCE_ID_WIX.PHOTOGRAPHY]: `${SITE_URLS[INSTANCE_ID_WIX.PHOTOGRAPHY]}/explore`,
    [INSTANCE_ID_WIX.RESTAURANTS]: `${SITE_URLS[INSTANCE_ID_WIX.RESTAURANTS]}/explore`,
    [INSTANCE_ID_WIX.FITNESS]: `${SITE_URLS[INSTANCE_ID_WIX.FITNESS]}/explore`,
    [INSTANCE_ID_WIX.ECOMMERCE]: SITE_URLS[INSTANCE_ID_WIX.ECOMMERCE],
    [INSTANCE_ID_WIX.BLOG_PL]: SITE_URLS[INSTANCE_ID_WIX.BLOG_PL],
    [INSTANCE_ID_WIX.BLOG_TR]: SITE_URLS[INSTANCE_ID_WIX.BLOG_TR],
    [INSTANCE_ID_WIX.BLOG_IT]: SITE_URLS[INSTANCE_ID_WIX.BLOG_IT],
    [INSTANCE_ID_WIX.BLOG_KO]: SITE_URLS[INSTANCE_ID_WIX.BLOG_KO],
    [INSTANCE_ID_WIX.BLOG_NL]: SITE_URLS[INSTANCE_ID_WIX.BLOG_NL],
    [INSTANCE_ID_WIX.BLOG_DE]: SITE_URLS[INSTANCE_ID_WIX.BLOG_DE],
    [INSTANCE_ID_WIX.BLOG_AUTOMATION]: SITE_URLS[INSTANCE_ID_WIX.BLOG_AUTOMATION],
};
export const POST_PAGE_URLS = {
    [INSTANCE_ID_WIX.ANSWERS]: SITE_URLS[INSTANCE_ID_WIX.ANSWERS],
    [INSTANCE_ID_WIX.CONTENT_WRITING]: SITE_URLS[INSTANCE_ID_WIX.CONTENT_WRITING],
    [INSTANCE_ID_WIX.CREATIVE]: SITE_URLS[INSTANCE_ID_WIX.CREATIVE],
    [INSTANCE_ID_WIX.BA]: SITE_URLS[INSTANCE_ID_WIX.BA],
    [INSTANCE_ID_WIX.BLOG]: SITE_URLS[INSTANCE_ID_WIX.BLOG],
    [INSTANCE_ID_WIX.BLOG_ES]: SITE_URLS[INSTANCE_ID_WIX.BLOG_ES],
    [INSTANCE_ID_WIX.BLOG_PT]: SITE_URLS[INSTANCE_ID_WIX.BLOG_PT],
    [INSTANCE_ID_WIX.BLOG_FR]: SITE_URLS[INSTANCE_ID_WIX.BLOG_FR],
    [INSTANCE_ID_WIX.BLOG_JA]: SITE_URLS[INSTANCE_ID_WIX.BLOG_JA],
    [INSTANCE_ID_WIX.BLOG_RU]: SITE_URLS[INSTANCE_ID_WIX.BLOG_RU],
    [INSTANCE_ID_WIX.PHOTOGRAPHY]: SITE_URLS[INSTANCE_ID_WIX.PHOTOGRAPHY],
    [INSTANCE_ID_WIX.RESTAURANTS]: SITE_URLS[INSTANCE_ID_WIX.RESTAURANTS],
    [INSTANCE_ID_WIX.FITNESS]: SITE_URLS[INSTANCE_ID_WIX.FITNESS],
    [INSTANCE_ID_WIX.ECOMMERCE]: SITE_URLS[INSTANCE_ID_WIX.ECOMMERCE],
    [INSTANCE_ID_WIX.BLOG_PL]: `${SITE_URLS[INSTANCE_ID_WIX.BLOG_PL]}/artykul`,
    [INSTANCE_ID_WIX.BLOG_TR]: `${SITE_URLS[INSTANCE_ID_WIX.BLOG_TR]}/makale`,
    [INSTANCE_ID_WIX.BLOG_IT]: `${SITE_URLS[INSTANCE_ID_WIX.BLOG_IT]}/articolo`,
    [INSTANCE_ID_WIX.BLOG_KO]: `${SITE_URLS[INSTANCE_ID_WIX.BLOG_KO]}/post`,
    [INSTANCE_ID_WIX.BLOG_NL]: `${SITE_URLS[INSTANCE_ID_WIX.BLOG_NL]}/post`,
    [INSTANCE_ID_WIX.BLOG_DE]: `${SITE_URLS[INSTANCE_ID_WIX.BLOG_DE]}/beitrag`,
    [INSTANCE_ID_WIX.BLOG_AUTOMATION]: `${SITE_URLS[INSTANCE_ID_WIX.BLOG_AUTOMATION]}/post`,
};
//# sourceMappingURL=wix-blogs.js.map